module.exports = __webpack_public_path__ + "img/sld_scb_20_t1_b1.08fa7705.svg";